import Vue from 'vue';

export default {

    SET_SEARCHTERM (state, searchTerm) {
      state.searchTerm = searchTerm
    },

};



// WEBPACK FOOTER //
// ./src/store/mutations.js